import { Theme } from '@mui/material/styles'

import { BRAND_ACCENT, BRAND_ACCENT_HOVER } from '../brandColors'

export default function LoadingButton(theme: Theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          '&.MuiButton-containedSecondary': {
            backgroundColor: BRAND_ACCENT,
            color: theme.palette.secondary.contrastText,
            '&:hover': {
              backgroundColor: BRAND_ACCENT_HOVER,
            },
          },
        },
      },
    },
  }
}
